<template>
  <div class="application">
    <el-tabs v-model="activeName"
             @tab-click="handleTableClick"
             class="tabs">
      <el-tab-pane label="全部"
                   name="-1"></el-tab-pane>
      <el-tab-pane label="待审核"
                   name="0"></el-tab-pane>
      <el-tab-pane label="审核通过"
                   name="1"></el-tab-pane>
      <el-tab-pane label="审核未通过"
                   name="2"></el-tab-pane>
    </el-tabs>
    <el-form :inline="true"
             :model="formInline"
             class="application-search"
             label-position="right">
      <el-form-item label="借款编号"
                    size="small">
        <el-input v-model="formInline.bankNo"
                  placeholder="请输入借款编号"></el-input>
      </el-form-item>
      <el-form-item label="物流公司"
                    size="small">
        <el-input v-model="formInline.name"
                  placeholder="请输入物流公司名称"></el-input>
      </el-form-item>
      <el-form-item class="btn_box">
        <el-button type="primary"
                   size="small"
                   class="search_btn"
                   @click="handleSearchClick">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="application_table">
      <el-table :data="data.result"
                style="width: 100%"
                height="100%"
                class="application-container">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40"
                         fixed>
        </el-table-column>
        <el-table-column class-name="companyName"
                         prop="bankNo"
                         label="借款编号">
        </el-table-column>
        <el-table-column prop="companyNameByShipper"
                         label="货主公司">
        </el-table-column>
        <el-table-column prop="companyNameByLogistics"
                         label="物流公司">
        </el-table-column>
        <el-table-column label="借款信息">
          <template slot-scope="scope">
            <div><span>金融机构：</span>{{scope.row.companyNameByFinancial}}</div>
            <div><span>借款金额：</span>{{scope.row.borrowingLimit}}</div>
            <div><span>借款时间：</span>{{scope.row.createDate}}</div>
            <div>
              <span>借款详情：</span>
              <el-popover placement="bottom"
                          trigger="click">
                <div class="details_info">
                  <div>放款时间：<span>{{scope.row.loanTime}}</span></div>
                  <div>年利率：<span>{{scope.row.interestRate}}%</span></div>
                  <div>借款利息：<span>{{scope.row.loanMoneyrate}}</span></div>
                  <div>借款期限(至)：<span>{{scope.row.borrowingTime}}</span></div>
                </div>
                <el-button slot="reference"
                           class="details"></el-button>
              </el-popover>

            </div>
          </template>
        </el-table-column>
        <el-table-column class-name="qualifiedInfo"
                         label="合同">
          <template slot-scope="scope">
            <!-- {{scope.row.qualifiedInfo.businessLicense}} -->
            <div class="qualifiedList">
              <div>第一页：</div><img @click="handlePactClick(scope.row.invoiceImg.imgUrl)"
                   v-if="scope.row.invoiceImg"
                   :src='scope.row.invoiceImg.imgUrl'
                   alt="合同-第一页">
            </div>
            <div class="qualifiedList">
              <div>第二页：</div><img @click="handlePactClick(scope.row.contractImg.imgUrl)"
                   v-if="scope.row.contractImg"
                   :src='scope.row.contractImg.imgUrl'
                   alt="合同-第二页">
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.companyToexamine==='0'"><span>平台审核：</span>待审核</div>
            <div v-else-if="scope.row.companyToexamine==='1'"><span>平台审核：</span>审核通过</div>
            <div v-else-if="scope.row.companyToexamine==='2'"><span>平台审核：</span>审核不通过</div>
            <div v-if="scope.row.bankToexamine === '-2'"><span>涌泉审核：</span>数据未同步</div>
            <div v-else-if="scope.row.bankToexamine === '-1'"><span>涌泉审核：</span>审核不通过</div>
            <div v-else-if="scope.row.bankToexamine === '0'"><span>涌泉审核：</span>审核中</div>
            <div v-else-if="scope.row.bankToexamine === '2'"><span>涌泉审核：</span>借款中</div>
            <div v-else-if="scope.row.bankToexamine === '4'"><span>涌泉审核：</span>代还款</div>
            <div v-else-if="scope.row.bankToexamine === '5'"><span>涌泉审核：</span>已还款</div>
          </template>
        </el-table-column>
        <el-table-column prop="remarks"
                         label="备注"
                         header-align="center"
                         align="center">
        </el-table-column>
        <el-table-column header-align="center"
                         prop="operation"
                         label="操作"
                         width="120"
                         align="center"
                         class-name="operation">
          <template slot-scope="scope">
            <el-button class="operate_btn"
                       @click="handleAuditClick(scope.row.id)">
              审核
            </el-button>

            <el-button class="operate_btn"
                       @click="handleSynchronizationClick(scope.row.id)">
              数据同步
            </el-button>
            <el-button class="operate_btn"
                       @click="handleReceiptClick(scope.row.id)">
              发票信息
            </el-button>
            <el-button class="operate_btn"
                       @click="handleChangeClick(scope.row.id)">
              修改
            </el-button>
          </template>

        </el-table-column>

      </el-table>
    </div>
    <el-dialog title="匹配详情"
               :visible.sync="showDetails"
               class="auditDetail"
               trigger="click">
      <div class="auditlist">
        <label for="updateStatus">
          审核：
        </label>
        <div class='versionRadio'>
          <el-radio v-model="radio"
                    label="1">审核通过</el-radio>
          <el-radio v-model="radio"
                    label="2">审核不通过</el-radio>
        </div>
      </div>
      <div class="auditlist"
           v-if="radio === '2'">
        <label for="remark">原因：</label>
        <el-input type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6}"
                  v-model="remarks"></el-input>
      </div>
      <button class="save"
              @click="handleSaveAuditClick">保存</button>
    </el-dialog>
    <el-dialog :title="titlename"
               :visible.sync="imgTab"
               class="imgTab">
      <el-carousel trigger="click"
                   arrow="always"
                   indicator-position='none'
                   :autoplay="false">
        <el-carousel-item v-for="(item,index) in imgList"
                          :key="index">
          <div class="imgMain">
            <img :src=item
                 alt="">
          </div>
          <div class="imgNums">{{index+1}}/{{imgList.length}}</div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{data.total}}条记录</span>
      <el-pagination @current-change='handleCurrentChange'
                     :page-size="data.pageSize"
                     layout="prev, pager, next"
                     :total="data.total"
                     background>
      </el-pagination>

    </div>
  </div>
</template>

<script>
import { bankapplyList, auditBankapply, receiptBankapply, dataSynchronization } from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      formInline: {
        bankNo: '',
        name: ''
      },
      showDetails: false,
      input: '',
      activeName: '-1',
      data: [],
      remarks: '',
      radio: '1',
      auditid: '',
      imgTab: false,
      titlename: '',
      imgList: [],
      pageNum: 1
    }
  },
  methods: {
    handleSearchClick () { // 查询
      this.getBankApplyData()
    },
    getBankApplyData () { // 获取信息
      let status = this.activeName === '-1' ? '' : this.activeName
      bankapplyList({
        companyToexamine: status,
        bankNo: this.formInline.bankNo,
        companyNameByLogistics: this.formInline.name,
        pageNum: this.pageNum
      }).then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data.result
        }
      })
    },
    handleAuditClick (id) { // 显示审核窗口
      this.auditid = ''
      this.radio = '1'
      this.remarks = ''
      this.showDetails = true
      this.auditid = id
    },
    handleSynchronizationClick (id) { // 数据同步
      // console.log(id)
      dataSynchronization({
        id: id
      }).then(res => {
        // console.log(res)
        if (res.data.code === 0) {
          this.$message({
            type: 'success',
            message: '数据同步申请已提交'
          })
        }
      })
    },
    handleSaveAuditClick () { // 处理审核信息
      if (this.radio === '2') {
        if (!this.remarks) {
          this.$message({
            type: 'warning',
            message: '请填写未通过原因!'
          })
        }
      }
      auditBankapply({
        companyToexamine: this.radio,
        remarks: this.remarks,
        id: this.auditid
      }).then(res => {
        if (res.data.code === 0) {
          this.getBankApplyData()
          this.showDetails = false
        }
      })
    },
    handleReceiptClick (id) { // 发票信息
      this.imgTab = true
      this.imgList = []
      this.titlename = '发票信息'
      receiptBankapply({ id: id }).then(res => {
        if (res.data.code === 0) {
          // console.log(res.data.data.result)
          // this.imgList = res.data.data.result
          if (res.data.data.result) {
            res.data.data.result.forEach(element => {
              this.imgList.push(element.img.imgUrl)
            })
          }
        }
      })
    },
    handlePactClick (item) { // 点击查看合同图片
      this.imgTab = true
      this.titlename = '合同信息'
      this.imgList = []
      this.imgList.push(item)
      // console.log(this.imgList)
    },
    handleChangeClick (id) { // 点击跳转修改页面
      this.$router.push({ path: 'apply/changeApply', query: { item: id } })
    },
    handleTableClick (tab, event) { // table
      this.getBankApplyData()
    },
    handleCurrentChange (val) { // 页面切换
      this.pageNum = val
    }
  },
  mounted () {
    this.getBankApplyData()
  }
}
</script>

<style lang="stylus">
@import '~styles/mixins.styl'
.application
  height 100%
  .tabs
    height 51px
    overflow hidden
    .el-tabs__nav-wrap::after
      height 1px
      bottom 1px
    .el-tabs__item
      padding 0
      text-align center
      height 51px
      line-height 50px
      width 92px
      size12()
      color #5e656f
      &:hover
        color #1b88ee
    .el-tabs__item.is-active
      border-bottom 2px solid #409EFF
      color #1b88ee
    .el-tabs__active-bar
      background transparent !important
  .application-search
    padding-top 10px
    padding-left 20px
    padding-right 20px
    .el-input
      width 146px
    .el-form-item
      margin-bottom 10px
    .btn_box
      float right
      .el-form-item__content
        line-height 30px
        .el-button
          searchBtn()
  .application_table
    width calc(100% - 40px) !important
    margin-left 20px
    height calc(100% - 160px)
    .el-table
      background #f7f9fb
    .el-table th
      background #e7f0f8
    .el-table td div
      size12()
    .el-table th>.cell
      size12()
    .qualifiedInfo
      .qualifiedList
        margin-top 3px
        overflow hidden
        span
          float left
          width 78px
          text-align right
        img
          width 80px
          height 48px
          margin-left 3px
          float left
    .details
      width 10px
      height 5px
      display inline-block
      background url('../../assets/images/06/Triangle.png') no-repeat
      cursor pointer
      padding 0
      border none
  .operation
    .el-button
      size12()
      margin-bottom 10px
      margin-left 10px
      width 78px
      height 28px
      padding 0
      &:nth-child(1)
        background #1B88EE
        color #ffffff
      &:nth-child(2)
        background #00D5B9
        color #ffffff
      &:nth-child(3)
        border 1px solid #1B88EE
        background #fff
        color #1B88EE
      &:nth-child(4)
        border 1px solid #1B88EE
        background #fff
        color #1B88EE
  .el-dialog
    width 728px
    height 390px
    .el-dialog__header
      height 42px
      padding 0 20px 0
      background #1b88ee
      .el-dialog__title
        line-height 42px
        font-size 13px
        color #fff
        float left
      .el-dialog__headerbtn
        top 12px
        right 12px
        .el-dialog__close
          color #fff
          font-size 20px
    .el-dialog__body
      padding 20px 20px 0
      .auditlist
        margin-top 20px
        label
          width 154px
          float left
          line-height 30px
          text-align right
          font-size 12px
          color #5E656F
        .el-textarea
          width 384px
          margin-left 12px
        .versionRadio
          height 30px
          .el-radio
            width 80px
            .el-radio__label
              color #212832
      .imgMain
        width 348px
        height 300px
        position relative
        margin 0 auto
        img
          height 100%
          position absolute
          top 50%
          left 50%
          transform translate(-50%, -50%)
      .imgNums
        position absolute
        bottom 0px
        left 50%
        transform translatex(-50%)
      .save
        width 112px
        height 28px
        background #1B88EE
        color #fff
        border-radius 3px
        position absolute
        bottom 50px
        left 50%
        cursor pointer
        margin-left -56px
  .pages
    margin 15px 20px 0
    .demonstartion
      float right
      line-height 45px
      color #5e656f
  .el-table td, .el-table th
    vertical-align top
.el-popover
  z-index 0
  line-height 1.6
  font-size 12px
  text-align left
  padding 0
  color #f66 !important
  border none
  .details_info
    position absolute
    background #FFFFFF
    border 1px solid #CFD5DC
    border-radius 3px
    z-index 100
    width 170px
    height 108px
    padding-top 8px
    padding-left 16px
    color #858C96
    span
      color #FF6F12
</style>
